import { render, staticRenderFns } from "./icons-edit.vue?vue&type=template&id=16ce013c&scoped=true&"
import script from "./icons-edit.vue?vue&type=script&lang=js&"
export * from "./icons-edit.vue?vue&type=script&lang=js&"
import style0 from "./icons-edit.vue?vue&type=style&index=0&id=16ce013c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ce013c",
  null
  
)

export default component.exports